<script lang="ts" setup>
import { Employee } from '../../components/EmployeeSingle.vue'

const props = defineProps<{
  title: string
  persons: Employee[]
}>()

const personsList = computed(() =>
  props.persons.filter((person, index, self) => index === self.findIndex((t) => t.name === person.name)),
)
</script>

<template>
  <SectionTitle class="text" :title="title" />

  <ul class="grid cul persons">
    <li v-for="(person, index) in personsList" :key="index" class="t-4">
      <ToccoContactPersonTeaser :person="person" :hide-images="true" />
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.persons {
  gap: 40px;
  @include fluid(margin-top, 30px, 40px);
}
</style>
